export const translationManualDetail = {
  cz: {
    previous: "Předchozí",
    next: "Další",
    description: "Popis",
  },
  en: {
    previous: "Previous",
    next: "Next",
    description: "Description",
  },
  de: {
    previous: "Zurück",
    next: "Weiter",
    description: "Beschreibung",
  },
  es: {
    previous: "Anterior",
    next: "Siguiente",
    description: "Descripción",
  },
  fr: {
    previous: "Précédent",
    next: "Suivant",
    description: "Description",
  },
  hu: {
    previous: "Előző",
    next: "Következő",
    description: "Leírás",
  },
  nl: {
    previous: "Vorige",
    next: "Volgende",
    description: "Beschrijving",
  },
  pl: {
    previous: "Poprzedni",
    next: "Następny",
    description: "Opis",
  },
  ru: {
    previous: "Предыдущий",
    next: "Следующий",
    description: "Описание",
  },
  sk: {
    previous: "Predchádzajúci",
    next: "Nasledujúci",
    description: "Popis",
  },
  sv: {
    previous: "Föregående",
    next: "Nästa",
    description: "Beskrivning",
  },
  no: {
    previous: "Forrige",
    next: "Neste",
    description: "Beskrivelse",
  },
  da: {
    previous: "Forrige",
    next: "Næste",
    description: "Beskrivelse",
  },
  fi: {
    previous: "Edellinen",
    next: "Seuraava",
    description: "Kuvaus",
  },
  ar: {
    previous: "السابق",
    next: "التالي",
    description: "الوصف",
  },
};

export default translationManualDetail;
